export default {
    aaa                       : 1,
    aarp                      : 1,
    abarth                    : 1,
    abb                       : 1,
    abbott                    : 1,
    abbvie                    : 1,
    abc                       : 1,
    able                      : 1,
    abogado                   : 1,
    abudhabi                  : 1,
    ac                        : 1,
    academy                   : 1,
    accenture                 : 1,
    accountant                : 1,
    accountants               : 1,
    aco                       : 1,
    actor                     : 1,
    ad                        : 1,
    adac                      : 1,
    ads                       : 1,
    adult                     : 1,
    ae                        : 1,
    aeg                       : 1,
    aero                      : 1,
    aetna                     : 1,
    af                        : 1,
    afamilycompany            : 1,
    afl                       : 1,
    africa                    : 1,
    ag                        : 1,
    agakhan                   : 1,
    agency                    : 1,
    ai                        : 1,
    aig                       : 1,
    airbus                    : 1,
    airforce                  : 1,
    airtel                    : 1,
    akdn                      : 1,
    al                        : 1,
    alfaromeo                 : 1,
    alibaba                   : 1,
    alipay                    : 1,
    allfinanz                 : 1,
    allstate                  : 1,
    ally                      : 1,
    alsace                    : 1,
    alstom                    : 1,
    am                        : 1,
    amazon                    : 1,
    americanexpress           : 1,
    americanfamily            : 1,
    amex                      : 1,
    amfam                     : 1,
    amica                     : 1,
    amsterdam                 : 1,
    analytics                 : 1,
    android                   : 1,
    anquan                    : 1,
    anz                       : 1,
    ao                        : 1,
    aol                       : 1,
    apartments                : 1,
    app                       : 1,
    apple                     : 1,
    aq                        : 1,
    aquarelle                 : 1,
    ar                        : 1,
    arab                      : 1,
    aramco                    : 1,
    archi                     : 1,
    army                      : 1,
    arpa                      : 1,
    art                       : 1,
    arte                      : 1,
    as                        : 1,
    asda                      : 1,
    asia                      : 1,
    associates                : 1,
    at                        : 1,
    athleta                   : 1,
    attorney                  : 1,
    au                        : 1,
    auction                   : 1,
    audi                      : 1,
    audible                   : 1,
    audio                     : 1,
    auspost                   : 1,
    author                    : 1,
    auto                      : 1,
    autos                     : 1,
    avianca                   : 1,
    aw                        : 1,
    aws                       : 1,
    ax                        : 1,
    axa                       : 1,
    az                        : 1,
    azure                     : 1,
    ba                        : 1,
    baby                      : 1,
    baidu                     : 1,
    banamex                   : 1,
    bananarepublic            : 1,
    band                      : 1,
    bank                      : 1,
    bar                       : 1,
    barcelona                 : 1,
    barclaycard               : 1,
    barclays                  : 1,
    barefoot                  : 1,
    bargains                  : 1,
    baseball                  : 1,
    basketball                : 1,
    bauhaus                   : 1,
    bayern                    : 1,
    bb                        : 1,
    bbc                       : 1,
    bbt                       : 1,
    bbva                      : 1,
    bcg                       : 1,
    bcn                       : 1,
    bd                        : 1,
    be                        : 1,
    beats                     : 1,
    beauty                    : 1,
    beer                      : 1,
    bentley                   : 1,
    berlin                    : 1,
    best                      : 1,
    bestbuy                   : 1,
    bet                       : 1,
    bf                        : 1,
    bg                        : 1,
    bh                        : 1,
    bharti                    : 1,
    bi                        : 1,
    bible                     : 1,
    bid                       : 1,
    bike                      : 1,
    bing                      : 1,
    bingo                     : 1,
    bio                       : 1,
    biz                       : 1,
    bj                        : 1,
    black                     : 1,
    blackfriday               : 1,
    blockbuster               : 1,
    blog                      : 1,
    bloomberg                 : 1,
    blue                      : 1,
    bm                        : 1,
    bms                       : 1,
    bmw                       : 1,
    bn                        : 1,
    bnpparibas                : 1,
    bo                        : 1,
    boats                     : 1,
    boehringer                : 1,
    bofa                      : 1,
    bom                       : 1,
    bond                      : 1,
    boo                       : 1,
    book                      : 1,
    booking                   : 1,
    bosch                     : 1,
    bostik                    : 1,
    boston                    : 1,
    bot                       : 1,
    boutique                  : 1,
    box                       : 1,
    br                        : 1,
    bradesco                  : 1,
    bridgestone               : 1,
    broadway                  : 1,
    broker                    : 1,
    brother                   : 1,
    brussels                  : 1,
    bs                        : 1,
    bt                        : 1,
    budapest                  : 1,
    bugatti                   : 1,
    build                     : 1,
    builders                  : 1,
    business                  : 1,
    buy                       : 1,
    buzz                      : 1,
    bv                        : 1,
    bw                        : 1,
    by                        : 1,
    bz                        : 1,
    bzh                       : 1,
    ca                        : 1,
    cab                       : 1,
    cafe                      : 1,
    cal                       : 1,
    call                      : 1,
    calvinklein               : 1,
    cam                       : 1,
    camera                    : 1,
    camp                      : 1,
    cancerresearch            : 1,
    canon                     : 1,
    capetown                  : 1,
    capital                   : 1,
    capitalone                : 1,
    car                       : 1,
    caravan                   : 1,
    cards                     : 1,
    care                      : 1,
    career                    : 1,
    careers                   : 1,
    cars                      : 1,
    casa                      : 1,
    case                      : 1,
    caseih                    : 1,
    cash                      : 1,
    casino                    : 1,
    cat                       : 1,
    catering                  : 1,
    catholic                  : 1,
    cba                       : 1,
    cbn                       : 1,
    cbre                      : 1,
    cbs                       : 1,
    cc                        : 1,
    cd                        : 1,
    center                    : 1,
    ceo                       : 1,
    cern                      : 1,
    cf                        : 1,
    cfa                       : 1,
    cfd                       : 1,
    cg                        : 1,
    ch                        : 1,
    chanel                    : 1,
    channel                   : 1,
    charity                   : 1,
    chase                     : 1,
    chat                      : 1,
    cheap                     : 1,
    chintai                   : 1,
    christmas                 : 1,
    chrome                    : 1,
    church                    : 1,
    ci                        : 1,
    cipriani                  : 1,
    circle                    : 1,
    cisco                     : 1,
    citadel                   : 1,
    citi                      : 1,
    citic                     : 1,
    city                      : 1,
    cityeats                  : 1,
    ck                        : 1,
    cl                        : 1,
    claims                    : 1,
    cleaning                  : 1,
    click                     : 1,
    clinic                    : 1,
    clinique                  : 1,
    clothing                  : 1,
    cloud                     : 1,
    club                      : 1,
    clubmed                   : 1,
    cm                        : 1,
    cn                        : 1,
    co                        : 1,
    coach                     : 1,
    codes                     : 1,
    coffee                    : 1,
    college                   : 1,
    cologne                   : 1,
    com                       : 1,
    comcast                   : 1,
    commbank                  : 1,
    community                 : 1,
    company                   : 1,
    compare                   : 1,
    computer                  : 1,
    comsec                    : 1,
    condos                    : 1,
    construction              : 1,
    consulting                : 1,
    contact                   : 1,
    contractors               : 1,
    cooking                   : 1,
    cookingchannel            : 1,
    cool                      : 1,
    coop                      : 1,
    corsica                   : 1,
    country                   : 1,
    coupon                    : 1,
    coupons                   : 1,
    courses                   : 1,
    cpa                       : 1,
    cr                        : 1,
    credit                    : 1,
    creditcard                : 1,
    creditunion               : 1,
    cricket                   : 1,
    crown                     : 1,
    crs                       : 1,
    cruise                    : 1,
    cruises                   : 1,
    csc                       : 1,
    cu                        : 1,
    cuisinella                : 1,
    cv                        : 1,
    cw                        : 1,
    cx                        : 1,
    cy                        : 1,
    cymru                     : 1,
    cyou                      : 1,
    cz                        : 1,
    dabur                     : 1,
    dad                       : 1,
    dance                     : 1,
    data                      : 1,
    date                      : 1,
    dating                    : 1,
    datsun                    : 1,
    day                       : 1,
    dclk                      : 1,
    dds                       : 1,
    de                        : 1,
    deal                      : 1,
    dealer                    : 1,
    deals                     : 1,
    degree                    : 1,
    delivery                  : 1,
    dell                      : 1,
    deloitte                  : 1,
    delta                     : 1,
    democrat                  : 1,
    dental                    : 1,
    dentist                   : 1,
    desi                      : 1,
    design                    : 1,
    dev                       : 1,
    dhl                       : 1,
    diamonds                  : 1,
    diet                      : 1,
    digital                   : 1,
    direct                    : 1,
    directory                 : 1,
    discount                  : 1,
    discover                  : 1,
    dish                      : 1,
    diy                       : 1,
    dj                        : 1,
    dk                        : 1,
    dm                        : 1,
    dnp                       : 1,
    do                        : 1,
    docs                      : 1,
    doctor                    : 1,
    dog                       : 1,
    domains                   : 1,
    dot                       : 1,
    download                  : 1,
    drive                     : 1,
    dtv                       : 1,
    dubai                     : 1,
    duck                      : 1,
    dunlop                    : 1,
    dupont                    : 1,
    durban                    : 1,
    dvag                      : 1,
    dvr                       : 1,
    dz                        : 1,
    earth                     : 1,
    eat                       : 1,
    ec                        : 1,
    eco                       : 1,
    edeka                     : 1,
    edu                       : 1,
    education                 : 1,
    ee                        : 1,
    eg                        : 1,
    email                     : 1,
    emerck                    : 1,
    energy                    : 1,
    engineer                  : 1,
    engineering               : 1,
    enterprises               : 1,
    epson                     : 1,
    equipment                 : 1,
    er                        : 1,
    ericsson                  : 1,
    erni                      : 1,
    es                        : 1,
    esq                       : 1,
    estate                    : 1,
    et                        : 1,
    etisalat                  : 1,
    eu                        : 1,
    eurovision                : 1,
    eus                       : 1,
    events                    : 1,
    exchange                  : 1,
    expert                    : 1,
    exposed                   : 1,
    express                   : 1,
    extraspace                : 1,
    fage                      : 1,
    fail                      : 1,
    fairwinds                 : 1,
    faith                     : 1,
    family                    : 1,
    fan                       : 1,
    fans                      : 1,
    farm                      : 1,
    farmers                   : 1,
    fashion                   : 1,
    fast                      : 1,
    fedex                     : 1,
    feedback                  : 1,
    ferrari                   : 1,
    ferrero                   : 1,
    fi                        : 1,
    fiat                      : 1,
    fidelity                  : 1,
    fido                      : 1,
    film                      : 1,
    final                     : 1,
    finance                   : 1,
    financial                 : 1,
    fire                      : 1,
    firestone                 : 1,
    firmdale                  : 1,
    fish                      : 1,
    fishing                   : 1,
    fit                       : 1,
    fitness                   : 1,
    fj                        : 1,
    fk                        : 1,
    flickr                    : 1,
    flights                   : 1,
    flir                      : 1,
    florist                   : 1,
    flowers                   : 1,
    fly                       : 1,
    fm                        : 1,
    fo                        : 1,
    foo                       : 1,
    food                      : 1,
    foodnetwork               : 1,
    football                  : 1,
    ford                      : 1,
    forex                     : 1,
    forsale                   : 1,
    forum                     : 1,
    foundation                : 1,
    fox                       : 1,
    fr                        : 1,
    free                      : 1,
    fresenius                 : 1,
    frl                       : 1,
    frogans                   : 1,
    frontdoor                 : 1,
    frontier                  : 1,
    ftr                       : 1,
    fujitsu                   : 1,
    fujixerox                 : 1,
    fun                       : 1,
    fund                      : 1,
    furniture                 : 1,
    futbol                    : 1,
    fyi                       : 1,
    ga                        : 1,
    gal                       : 1,
    gallery                   : 1,
    gallo                     : 1,
    gallup                    : 1,
    game                      : 1,
    games                     : 1,
    gap                       : 1,
    garden                    : 1,
    gay                       : 1,
    gb                        : 1,
    gbiz                      : 1,
    gd                        : 1,
    gdn                       : 1,
    ge                        : 1,
    gea                       : 1,
    gent                      : 1,
    genting                   : 1,
    george                    : 1,
    gf                        : 1,
    gg                        : 1,
    ggee                      : 1,
    gh                        : 1,
    gi                        : 1,
    gift                      : 1,
    gifts                     : 1,
    gives                     : 1,
    giving                    : 1,
    gl                        : 1,
    glade                     : 1,
    glass                     : 1,
    gle                       : 1,
    global                    : 1,
    globo                     : 1,
    gm                        : 1,
    gmail                     : 1,
    gmbh                      : 1,
    gmo                       : 1,
    gmx                       : 1,
    gn                        : 1,
    godaddy                   : 1,
    gold                      : 1,
    goldpoint                 : 1,
    golf                      : 1,
    goo                       : 1,
    goodyear                  : 1,
    goog                      : 1,
    google                    : 1,
    gop                       : 1,
    got                       : 1,
    gov                       : 1,
    gp                        : 1,
    gq                        : 1,
    gr                        : 1,
    grainger                  : 1,
    graphics                  : 1,
    gratis                    : 1,
    green                     : 1,
    gripe                     : 1,
    grocery                   : 1,
    group                     : 1,
    gs                        : 1,
    gt                        : 1,
    gu                        : 1,
    guardian                  : 1,
    gucci                     : 1,
    guge                      : 1,
    guide                     : 1,
    guitars                   : 1,
    guru                      : 1,
    gw                        : 1,
    gy                        : 1,
    hair                      : 1,
    hamburg                   : 1,
    hangout                   : 1,
    haus                      : 1,
    hbo                       : 1,
    hdfc                      : 1,
    hdfcbank                  : 1,
    health                    : 1,
    healthcare                : 1,
    help                      : 1,
    helsinki                  : 1,
    here                      : 1,
    hermes                    : 1,
    hgtv                      : 1,
    hiphop                    : 1,
    hisamitsu                 : 1,
    hitachi                   : 1,
    hiv                       : 1,
    hk                        : 1,
    hkt                       : 1,
    hm                        : 1,
    hn                        : 1,
    hockey                    : 1,
    holdings                  : 1,
    holiday                   : 1,
    homedepot                 : 1,
    homegoods                 : 1,
    homes                     : 1,
    homesense                 : 1,
    honda                     : 1,
    horse                     : 1,
    hospital                  : 1,
    host                      : 1,
    hosting                   : 1,
    hot                       : 1,
    hoteles                   : 1,
    hotels                    : 1,
    hotmail                   : 1,
    house                     : 1,
    how                       : 1,
    hr                        : 1,
    hsbc                      : 1,
    ht                        : 1,
    hu                        : 1,
    hughes                    : 1,
    hyatt                     : 1,
    hyundai                   : 1,
    ibm                       : 1,
    icbc                      : 1,
    ice                       : 1,
    icu                       : 1,
    id                        : 1,
    ie                        : 1,
    ieee                      : 1,
    ifm                       : 1,
    ikano                     : 1,
    il                        : 1,
    im                        : 1,
    imamat                    : 1,
    imdb                      : 1,
    immo                      : 1,
    immobilien                : 1,
    in                        : 1,
    inc                       : 1,
    industries                : 1,
    infiniti                  : 1,
    info                      : 1,
    ing                       : 1,
    ink                       : 1,
    institute                 : 1,
    insurance                 : 1,
    insure                    : 1,
    int                       : 1,
    international             : 1,
    intuit                    : 1,
    investments               : 1,
    io                        : 1,
    ipiranga                  : 1,
    iq                        : 1,
    ir                        : 1,
    irish                     : 1,
    is                        : 1,
    ismaili                   : 1,
    ist                       : 1,
    istanbul                  : 1,
    it                        : 1,
    itau                      : 1,
    itv                       : 1,
    iveco                     : 1,
    jaguar                    : 1,
    java                      : 1,
    jcb                       : 1,
    je                        : 1,
    jeep                      : 1,
    jetzt                     : 1,
    jewelry                   : 1,
    jio                       : 1,
    jll                       : 1,
    jm                        : 1,
    jmp                       : 1,
    jnj                       : 1,
    jo                        : 1,
    jobs                      : 1,
    joburg                    : 1,
    jot                       : 1,
    joy                       : 1,
    jp                        : 1,
    jpmorgan                  : 1,
    jprs                      : 1,
    juegos                    : 1,
    juniper                   : 1,
    kaufen                    : 1,
    kddi                      : 1,
    ke                        : 1,
    kerryhotels               : 1,
    kerrylogistics            : 1,
    kerryproperties           : 1,
    kfh                       : 1,
    kg                        : 1,
    kh                        : 1,
    ki                        : 1,
    kia                       : 1,
    kim                       : 1,
    kinder                    : 1,
    kindle                    : 1,
    kitchen                   : 1,
    kiwi                      : 1,
    km                        : 1,
    kn                        : 1,
    koeln                     : 1,
    komatsu                   : 1,
    kosher                    : 1,
    kp                        : 1,
    kpmg                      : 1,
    kpn                       : 1,
    kr                        : 1,
    krd                       : 1,
    kred                      : 1,
    kuokgroup                 : 1,
    kw                        : 1,
    ky                        : 1,
    kyoto                     : 1,
    kz                        : 1,
    la                        : 1,
    lacaixa                   : 1,
    lamborghini               : 1,
    lamer                     : 1,
    lancaster                 : 1,
    lancia                    : 1,
    land                      : 1,
    landrover                 : 1,
    lanxess                   : 1,
    lasalle                   : 1,
    lat                       : 1,
    latino                    : 1,
    latrobe                   : 1,
    law                       : 1,
    lawyer                    : 1,
    lb                        : 1,
    lc                        : 1,
    lds                       : 1,
    lease                     : 1,
    leclerc                   : 1,
    lefrak                    : 1,
    legal                     : 1,
    lego                      : 1,
    lexus                     : 1,
    lgbt                      : 1,
    li                        : 1,
    lidl                      : 1,
    life                      : 1,
    lifeinsurance             : 1,
    lifestyle                 : 1,
    lighting                  : 1,
    like                      : 1,
    lilly                     : 1,
    limited                   : 1,
    limo                      : 1,
    lincoln                   : 1,
    linde                     : 1,
    link                      : 1,
    lipsy                     : 1,
    live                      : 1,
    living                    : 1,
    lixil                     : 1,
    lk                        : 1,
    llc                       : 1,
    llp                       : 1,
    loan                      : 1,
    loans                     : 1,
    locker                    : 1,
    locus                     : 1,
    loft                      : 1,
    lol                       : 1,
    london                    : 1,
    lotte                     : 1,
    lotto                     : 1,
    love                      : 1,
    lpl                       : 1,
    lplfinancial              : 1,
    lr                        : 1,
    ls                        : 1,
    lt                        : 1,
    ltd                       : 1,
    ltda                      : 1,
    lu                        : 1,
    lundbeck                  : 1,
    luxe                      : 1,
    luxury                    : 1,
    lv                        : 1,
    ly                        : 1,
    ma                        : 1,
    macys                     : 1,
    madrid                    : 1,
    maif                      : 1,
    maison                    : 1,
    makeup                    : 1,
    man                       : 1,
    management                : 1,
    mango                     : 1,
    map                       : 1,
    market                    : 1,
    marketing                 : 1,
    markets                   : 1,
    marriott                  : 1,
    marshalls                 : 1,
    maserati                  : 1,
    mattel                    : 1,
    mba                       : 1,
    mc                        : 1,
    mckinsey                  : 1,
    md                        : 1,
    me                        : 1,
    med                       : 1,
    media                     : 1,
    meet                      : 1,
    melbourne                 : 1,
    meme                      : 1,
    memorial                  : 1,
    men                       : 1,
    menu                      : 1,
    merckmsd                  : 1,
    mg                        : 1,
    mh                        : 1,
    miami                     : 1,
    microsoft                 : 1,
    mil                       : 1,
    mini                      : 1,
    mint                      : 1,
    mit                       : 1,
    mitsubishi                : 1,
    mk                        : 1,
    ml                        : 1,
    mlb                       : 1,
    mls                       : 1,
    mm                        : 1,
    mma                       : 1,
    mn                        : 1,
    mo                        : 1,
    mobi                      : 1,
    mobile                    : 1,
    moda                      : 1,
    moe                       : 1,
    moi                       : 1,
    mom                       : 1,
    monash                    : 1,
    money                     : 1,
    monster                   : 1,
    mormon                    : 1,
    mortgage                  : 1,
    moscow                    : 1,
    moto                      : 1,
    motorcycles               : 1,
    mov                       : 1,
    movie                     : 1,
    mp                        : 1,
    mq                        : 1,
    mr                        : 1,
    ms                        : 1,
    msd                       : 1,
    mt                        : 1,
    mtn                       : 1,
    mtr                       : 1,
    mu                        : 1,
    museum                    : 1,
    mutual                    : 1,
    mv                        : 1,
    mw                        : 1,
    mx                        : 1,
    my                        : 1,
    mz                        : 1,
    na                        : 1,
    nab                       : 1,
    nagoya                    : 1,
    name                      : 1,
    nationwide                : 1,
    natura                    : 1,
    navy                      : 1,
    nba                       : 1,
    nc                        : 1,
    ne                        : 1,
    nec                       : 1,
    net                       : 1,
    netbank                   : 1,
    netflix                   : 1,
    network                   : 1,
    neustar                   : 1,
    new                       : 1,
    newholland                : 1,
    news                      : 1,
    next                      : 1,
    nextdirect                : 1,
    nexus                     : 1,
    nf                        : 1,
    nfl                       : 1,
    ng                        : 1,
    ngo                       : 1,
    nhk                       : 1,
    ni                        : 1,
    nico                      : 1,
    nike                      : 1,
    nikon                     : 1,
    ninja                     : 1,
    nissan                    : 1,
    nissay                    : 1,
    nl                        : 1,
    no                        : 1,
    nokia                     : 1,
    northwesternmutual        : 1,
    norton                    : 1,
    now                       : 1,
    nowruz                    : 1,
    nowtv                     : 1,
    np                        : 1,
    nr                        : 1,
    nra                       : 1,
    nrw                       : 1,
    ntt                       : 1,
    nu                        : 1,
    nyc                       : 1,
    nz                        : 1,
    obi                       : 1,
    observer                  : 1,
    off                       : 1,
    office                    : 1,
    okinawa                   : 1,
    olayan                    : 1,
    olayangroup               : 1,
    oldnavy                   : 1,
    ollo                      : 1,
    om                        : 1,
    omega                     : 1,
    one                       : 1,
    ong                       : 1,
    onl                       : 1,
    online                    : 1,
    onyourside                : 1,
    ooo                       : 1,
    open                      : 1,
    oracle                    : 1,
    orange                    : 1,
    org                       : 1,
    organic                   : 1,
    origins                   : 1,
    osaka                     : 1,
    otsuka                    : 1,
    ott                       : 1,
    ovh                       : 1,
    pa                        : 1,
    page                      : 1,
    panasonic                 : 1,
    paris                     : 1,
    pars                      : 1,
    partners                  : 1,
    parts                     : 1,
    party                     : 1,
    passagens                 : 1,
    pay                       : 1,
    pccw                      : 1,
    pe                        : 1,
    pet                       : 1,
    pf                        : 1,
    pfizer                    : 1,
    pg                        : 1,
    ph                        : 1,
    pharmacy                  : 1,
    phd                       : 1,
    philips                   : 1,
    phone                     : 1,
    photo                     : 1,
    photography               : 1,
    photos                    : 1,
    physio                    : 1,
    pics                      : 1,
    pictet                    : 1,
    pictures                  : 1,
    pid                       : 1,
    pin                       : 1,
    ping                      : 1,
    pink                      : 1,
    pioneer                   : 1,
    pizza                     : 1,
    pk                        : 1,
    pl                        : 1,
    place                     : 1,
    play                      : 1,
    playstation               : 1,
    plumbing                  : 1,
    plus                      : 1,
    pm                        : 1,
    pn                        : 1,
    pnc                       : 1,
    pohl                      : 1,
    poker                     : 1,
    politie                   : 1,
    porn                      : 1,
    post                      : 1,
    pr                        : 1,
    pramerica                 : 1,
    praxi                     : 1,
    press                     : 1,
    prime                     : 1,
    pro                       : 1,
    prod                      : 1,
    productions               : 1,
    prof                      : 1,
    progressive               : 1,
    promo                     : 1,
    properties                : 1,
    property                  : 1,
    protection                : 1,
    pru                       : 1,
    prudential                : 1,
    ps                        : 1,
    pt                        : 1,
    pub                       : 1,
    pw                        : 1,
    pwc                       : 1,
    py                        : 1,
    qa                        : 1,
    qpon                      : 1,
    quebec                    : 1,
    quest                     : 1,
    qvc                       : 1,
    racing                    : 1,
    radio                     : 1,
    raid                      : 1,
    re                        : 1,
    read                      : 1,
    realestate                : 1,
    realtor                   : 1,
    realty                    : 1,
    recipes                   : 1,
    red                       : 1,
    redstone                  : 1,
    redumbrella               : 1,
    rehab                     : 1,
    reise                     : 1,
    reisen                    : 1,
    reit                      : 1,
    reliance                  : 1,
    ren                       : 1,
    rent                      : 1,
    rentals                   : 1,
    repair                    : 1,
    report                    : 1,
    republican                : 1,
    rest                      : 1,
    restaurant                : 1,
    review                    : 1,
    reviews                   : 1,
    rexroth                   : 1,
    rich                      : 1,
    richardli                 : 1,
    ricoh                     : 1,
    ril                       : 1,
    rio                       : 1,
    rip                       : 1,
    rmit                      : 1,
    ro                        : 1,
    rocher                    : 1,
    rocks                     : 1,
    rodeo                     : 1,
    rogers                    : 1,
    room                      : 1,
    rs                        : 1,
    rsvp                      : 1,
    ru                        : 1,
    rugby                     : 1,
    ruhr                      : 1,
    run                       : 1,
    rw                        : 1,
    rwe                       : 1,
    ryukyu                    : 1,
    sa                        : 1,
    saarland                  : 1,
    safe                      : 1,
    safety                    : 1,
    sakura                    : 1,
    sale                      : 1,
    salon                     : 1,
    samsclub                  : 1,
    samsung                   : 1,
    sandvik                   : 1,
    sandvikcoromant           : 1,
    sanofi                    : 1,
    sap                       : 1,
    sarl                      : 1,
    sas                       : 1,
    save                      : 1,
    saxo                      : 1,
    sb                        : 1,
    sbi                       : 1,
    sbs                       : 1,
    sc                        : 1,
    sca                       : 1,
    scb                       : 1,
    schaeffler                : 1,
    schmidt                   : 1,
    scholarships              : 1,
    school                    : 1,
    schule                    : 1,
    schwarz                   : 1,
    science                   : 1,
    scjohnson                 : 1,
    scot                      : 1,
    sd                        : 1,
    se                        : 1,
    search                    : 1,
    seat                      : 1,
    secure                    : 1,
    security                  : 1,
    seek                      : 1,
    select                    : 1,
    sener                     : 1,
    services                  : 1,
    ses                       : 1,
    seven                     : 1,
    sew                       : 1,
    sex                       : 1,
    sexy                      : 1,
    sfr                       : 1,
    sg                        : 1,
    sh                        : 1,
    shangrila                 : 1,
    sharp                     : 1,
    shaw                      : 1,
    shell                     : 1,
    shia                      : 1,
    shiksha                   : 1,
    shoes                     : 1,
    shop                      : 1,
    shopping                  : 1,
    shouji                    : 1,
    show                      : 1,
    showtime                  : 1,
    si                        : 1,
    silk                      : 1,
    sina                      : 1,
    singles                   : 1,
    site                      : 1,
    sj                        : 1,
    sk                        : 1,
    ski                       : 1,
    skin                      : 1,
    sky                       : 1,
    skype                     : 1,
    sl                        : 1,
    sling                     : 1,
    sm                        : 1,
    smart                     : 1,
    smile                     : 1,
    sn                        : 1,
    sncf                      : 1,
    so                        : 1,
    soccer                    : 1,
    social                    : 1,
    softbank                  : 1,
    software                  : 1,
    sohu                      : 1,
    solar                     : 1,
    solutions                 : 1,
    song                      : 1,
    sony                      : 1,
    soy                       : 1,
    spa                       : 1,
    space                     : 1,
    sport                     : 1,
    spot                      : 1,
    spreadbetting             : 1,
    sr                        : 1,
    srl                       : 1,
    ss                        : 1,
    st                        : 1,
    stada                     : 1,
    staples                   : 1,
    star                      : 1,
    statebank                 : 1,
    statefarm                 : 1,
    stc                       : 1,
    stcgroup                  : 1,
    stockholm                 : 1,
    storage                   : 1,
    store                     : 1,
    stream                    : 1,
    studio                    : 1,
    study                     : 1,
    style                     : 1,
    su                        : 1,
    sucks                     : 1,
    supplies                  : 1,
    supply                    : 1,
    support                   : 1,
    surf                      : 1,
    surgery                   : 1,
    suzuki                    : 1,
    sv                        : 1,
    swatch                    : 1,
    swiftcover                : 1,
    swiss                     : 1,
    sx                        : 1,
    sy                        : 1,
    sydney                    : 1,
    systems                   : 1,
    sz                        : 1,
    tab                       : 1,
    taipei                    : 1,
    talk                      : 1,
    taobao                    : 1,
    target                    : 1,
    tatamotors                : 1,
    tatar                     : 1,
    tattoo                    : 1,
    tax                       : 1,
    taxi                      : 1,
    tc                        : 1,
    tci                       : 1,
    td                        : 1,
    tdk                       : 1,
    team                      : 1,
    tech                      : 1,
    technology                : 1,
    tel                       : 1,
    temasek                   : 1,
    tennis                    : 1,
    teva                      : 1,
    tf                        : 1,
    tg                        : 1,
    th                        : 1,
    thd                       : 1,
    theater                   : 1,
    theatre                   : 1,
    tiaa                      : 1,
    tickets                   : 1,
    tienda                    : 1,
    tiffany                   : 1,
    tips                      : 1,
    tires                     : 1,
    tirol                     : 1,
    tj                        : 1,
    tjmaxx                    : 1,
    tjx                       : 1,
    tk                        : 1,
    tkmaxx                    : 1,
    tl                        : 1,
    tm                        : 1,
    tmall                     : 1,
    tn                        : 1,
    to                        : 1,
    today                     : 1,
    tokyo                     : 1,
    tools                     : 1,
    top                       : 1,
    toray                     : 1,
    toshiba                   : 1,
    total                     : 1,
    tours                     : 1,
    town                      : 1,
    toyota                    : 1,
    toys                      : 1,
    tr                        : 1,
    trade                     : 1,
    trading                   : 1,
    training                  : 1,
    travel                    : 1,
    travelchannel             : 1,
    travelers                 : 1,
    travelersinsurance        : 1,
    trust                     : 1,
    trv                       : 1,
    tt                        : 1,
    tube                      : 1,
    tui                       : 1,
    tunes                     : 1,
    tushu                     : 1,
    tv                        : 1,
    tvs                       : 1,
    tw                        : 1,
    tz                        : 1,
    ua                        : 1,
    ubank                     : 1,
    ubs                       : 1,
    ug                        : 1,
    uk                        : 1,
    unicom                    : 1,
    university                : 1,
    uno                       : 1,
    uol                       : 1,
    ups                       : 1,
    us                        : 1,
    uy                        : 1,
    uz                        : 1,
    va                        : 1,
    vacations                 : 1,
    vana                      : 1,
    vanguard                  : 1,
    vc                        : 1,
    ve                        : 1,
    vegas                     : 1,
    ventures                  : 1,
    verisign                  : 1,
    versicherung              : 1,
    vet                       : 1,
    vg                        : 1,
    vi                        : 1,
    viajes                    : 1,
    video                     : 1,
    vig                       : 1,
    viking                    : 1,
    villas                    : 1,
    vin                       : 1,
    vip                       : 1,
    virgin                    : 1,
    visa                      : 1,
    vision                    : 1,
    viva                      : 1,
    vivo                      : 1,
    vlaanderen                : 1,
    vn                        : 1,
    vodka                     : 1,
    volkswagen                : 1,
    volvo                     : 1,
    vote                      : 1,
    voting                    : 1,
    voto                      : 1,
    voyage                    : 1,
    vu                        : 1,
    vuelos                    : 1,
    wales                     : 1,
    walmart                   : 1,
    walter                    : 1,
    wang                      : 1,
    wanggou                   : 1,
    watch                     : 1,
    watches                   : 1,
    weather                   : 1,
    weatherchannel            : 1,
    webcam                    : 1,
    weber                     : 1,
    website                   : 1,
    wed                       : 1,
    wedding                   : 1,
    weibo                     : 1,
    weir                      : 1,
    wf                        : 1,
    whoswho                   : 1,
    wien                      : 1,
    wiki                      : 1,
    williamhill               : 1,
    win                       : 1,
    windows                   : 1,
    wine                      : 1,
    winners                   : 1,
    wme                       : 1,
    wolterskluwer             : 1,
    woodside                  : 1,
    work                      : 1,
    works                     : 1,
    world                     : 1,
    wow                       : 1,
    ws                        : 1,
    wtc                       : 1,
    wtf                       : 1,
    xbox                      : 1,
    xerox                     : 1,
    xfinity                   : 1,
    xihuan                    : 1,
    xin                       : 1,
    "xn--11b4c3d"             : 1,
    "xn--1ck2e1b"             : 1,
    "xn--1qqw23a"             : 1,
    "xn--2scrj9c"             : 1,
    "xn--30rr7y"              : 1,
    "xn--3bst00m"             : 1,
    "xn--3ds443g"             : 1,
    "xn--3e0b707e"            : 1,
    "xn--3hcrj9c"             : 1,
    "xn--3oq18vl8pn36a"       : 1,
    "xn--3pxu8k"              : 1,
    "xn--42c2d9a"             : 1,
    "xn--45br5cyl"            : 1,
    "xn--45brj9c"             : 1,
    "xn--45q11c"              : 1,
    "xn--4gbrim"              : 1,
    "xn--54b7fta0cc"          : 1,
    "xn--55qw42g"             : 1,
    "xn--55qx5d"              : 1,
    "xn--5su34j936bgsg"       : 1,
    "xn--5tzm5g"              : 1,
    "xn--6frz82g"             : 1,
    "xn--6qq986b3xl"          : 1,
    "xn--80adxhks"            : 1,
    "xn--80ao21a"             : 1,
    "xn--80aqecdr1a"          : 1,
    "xn--80asehdb"            : 1,
    "xn--80aswg"              : 1,
    "xn--8y0a063a"            : 1,
    "xn--90a3ac"              : 1,
    "xn--90ae"                : 1,
    "xn--90ais"               : 1,
    "xn--9dbq2a"              : 1,
    "xn--9et52u"              : 1,
    "xn--9krt00a"             : 1,
    "xn--b4w605ferd"          : 1,
    "xn--bck1b9a5dre4c"       : 1,
    "xn--c1avg"               : 1,
    "xn--c2br7g"              : 1,
    "xn--cck2b3b"             : 1,
    "xn--cckwcxetd"           : 1,
    "xn--cg4bki"              : 1,
    "xn--clchc0ea0b2g2a9gcd"  : 1,
    "xn--czr694b"             : 1,
    "xn--czrs0t"              : 1,
    "xn--czru2d"              : 1,
    "xn--d1acj3b"             : 1,
    "xn--d1alf"               : 1,
    "xn--e1a4c"               : 1,
    "xn--eckvdtc9d"           : 1,
    "xn--efvy88h"             : 1,
    "xn--fct429k"             : 1,
    "xn--fhbei"               : 1,
    "xn--fiq228c5hs"          : 1,
    "xn--fiq64b"              : 1,
    "xn--fiqs8s"              : 1,
    "xn--fiqz9s"              : 1,
    "xn--fjq720a"             : 1,
    "xn--flw351e"             : 1,
    "xn--fpcrj9c3d"           : 1,
    "xn--fzc2c9e2c"           : 1,
    "xn--fzys8d69uvgm"        : 1,
    "xn--g2xx48c"             : 1,
    "xn--gckr3f0f"            : 1,
    "xn--gecrj9c"             : 1,
    "xn--gk3at1e"             : 1,
    "xn--h2breg3eve"          : 1,
    "xn--h2brj9c"             : 1,
    "xn--h2brj9c8c"           : 1,
    "xn--hxt814e"             : 1,
    "xn--i1b6b1a6a2e"         : 1,
    "xn--imr513n"             : 1,
    "xn--io0a7i"              : 1,
    "xn--j1aef"               : 1,
    "xn--j1amh"               : 1,
    "xn--j6w193g"             : 1,
    "xn--jlq480n2rg"          : 1,
    "xn--jlq61u9w7b"          : 1,
    "xn--jvr189m"             : 1,
    "xn--kcrx77d1x4a"         : 1,
    "xn--kprw13d"             : 1,
    "xn--kpry57d"             : 1,
    "xn--kput3i"              : 1,
    "xn--l1acc"               : 1,
    "xn--lgbbat1ad8j"         : 1,
    "xn--mgb9awbf"            : 1,
    "xn--mgba3a3ejt"          : 1,
    "xn--mgba3a4f16a"         : 1,
    "xn--mgba7c0bbn0a"        : 1,
    "xn--mgbaakc7dvf"         : 1,
    "xn--mgbaam7a8h"          : 1,
    "xn--mgbab2bd"            : 1,
    "xn--mgbah1a3hjkrd"       : 1,
    "xn--mgbai9azgqp6j"       : 1,
    "xn--mgbayh7gpa"          : 1,
    "xn--mgbbh1a"             : 1,
    "xn--mgbbh1a71e"          : 1,
    "xn--mgbc0a9azcg"         : 1,
    "xn--mgbca7dzdo"          : 1,
    "xn--mgbcpq6gpa1a"        : 1,
    "xn--mgberp4a5d4ar"       : 1,
    "xn--mgbgu82a"            : 1,
    "xn--mgbi4ecexp"          : 1,
    "xn--mgbpl2fh"            : 1,
    "xn--mgbt3dhd"            : 1,
    "xn--mgbtx2b"             : 1,
    "xn--mgbx4cd0ab"          : 1,
    "xn--mix891f"             : 1,
    "xn--mk1bu44c"            : 1,
    "xn--mxtq1m"              : 1,
    "xn--ngbc5azd"            : 1,
    "xn--ngbe9e0a"            : 1,
    "xn--ngbrx"               : 1,
    "xn--node"                : 1,
    "xn--nqv7f"               : 1,
    "xn--nqv7fs00ema"         : 1,
    "xn--nyqy26a"             : 1,
    "xn--o3cw4h"              : 1,
    "xn--ogbpf8fl"            : 1,
    "xn--otu796d"             : 1,
    "xn--p1acf"               : 1,
    "xn--p1ai"                : 1,
    "xn--pgbs0dh"             : 1,
    "xn--pssy2u"              : 1,
    "xn--q7ce6a"              : 1,
    "xn--q9jyb4c"             : 1,
    "xn--qcka1pmc"            : 1,
    "xn--qxa6a"               : 1,
    "xn--qxam"                : 1,
    "xn--rhqv96g"             : 1,
    "xn--rovu88b"             : 1,
    "xn--rvc1e0am3e"          : 1,
    "xn--s9brj9c"             : 1,
    "xn--ses554g"             : 1,
    "xn--t60b56a"             : 1,
    "xn--tckwe"               : 1,
    "xn--tiq49xqyj"           : 1,
    "xn--unup4y"              : 1,
    "xn--vermgensberater-ctb" : 1,
    "xn--vermgensberatung-pwb": 1,
    "xn--vhquv"               : 1,
    "xn--vuq861b"             : 1,
    "xn--w4r85el8fhu5dnra"    : 1,
    "xn--w4rs40l"             : 1,
    "xn--wgbh1c"              : 1,
    "xn--wgbl6a"              : 1,
    "xn--xhq521b"             : 1,
    "xn--xkc2al3hye2a"        : 1,
    "xn--xkc2dl3a5ee0h"       : 1,
    "xn--y9a3aq"              : 1,
    "xn--yfro4i67o"           : 1,
    "xn--ygbi2ammx"           : 1,
    "xn--zfr164b"             : 1,
    xxx                       : 1,
    xyz                       : 1,
    yachts                    : 1,
    yahoo                     : 1,
    yamaxun                   : 1,
    yandex                    : 1,
    ye                        : 1,
    yodobashi                 : 1,
    yoga                      : 1,
    yokohama                  : 1,
    you                       : 1,
    youtube                   : 1,
    yt                        : 1,
    yun                       : 1,
    za                        : 1,
    zappos                    : 1,
    zara                      : 1,
    zero                      : 1,
    zip                       : 1,
    zm                        : 1,
    zone                      : 1,
    zuerich                   : 1,
    zw                        : 1
};